import styled from 'styled-components';
import { Table, Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

export const StyledButton = styled(Button)`
  &&& {
    display: flex;
    background-color: #1b1c1d;
    color: #fff;
    transition: background-color .3s ease;
    height: 35px;
    margin-left: 5px;
  }
`;

export const ContainerInputSearch  = styled.div`
  width: 100%;
  height: 50px;
  
  & i{
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width:100%;
  height:35px;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  tfoot{
    a{
      color: #000000 !important;

      i{
        color: #000000 !important;
      }
    }
  }
`;

export const LinkRedirect = styled(Link)`
  color: #2185d0 !important;
  cursor: default;

  &:hover{
    text-decoration: none;
    color: #2d8cd4 !important;
  }
`;

export const SemanticButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${props => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }

  transition: all 0.6s;
`;

export const Mail = styled(Icon)`
  background: none;
  color: #2185D0 !important;
  cursor: pointer;
`;
